/**
 * Returns whether {@link} url is a valid URL, either absolute or relative.
 */
export var getIsValidUrl = function (url) {
    try {
        new URL(url, window.location.origin);
        return true;
    }
    catch (e) {
        return false;
    }
};
